export const phoneFormat = (value) => {
  const newPhone = _.replace(value, /-/g, '')
  if (_.isNull(newPhone)) return null
  return newPhone.replace(/(\S{3})(\S{4})(\S+)/, '$1-$2-$3')
}

export const zipFormat = (value) => {
  const newZipcode = _.replace(value, /-/g, '')
  if (_.isNull(newZipcode)) return null
  return newZipcode.replace(/(\S{3})(\S{4})/, '$1-$2')
}
